/* eslint-disable */
class BackGroundStyles {
    constructor() {
    }

    get(background) {
      let styleObj = (!background?.image) ? {
        backgroundColor: background
      } :
        {
          backgroundImage: background.image,
          backgroundSize: (background.isSize_Cover) ? 'center/cover': '',
          backgroundRepeat: (background.isNoRepeat) ? 'no-repeat': 'repeat'
        }
      return styleObj;
    }
}

export default BackGroundStyles;
